import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';

export enum ESnackbar {
  error = 'red-snackbar',
  success = 'green-snackbar',
}

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  public open(message: string, type?: ESnackbar, duration?: number, action?: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.snackBar.open(message, action || undefined, {
      duration: duration !== undefined ? duration : 10000,
      horizontalPosition: 'center',
      panelClass: type ? type : [],
    });
  }
}
